// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React, { useContext } from 'react';
import message from '../../messages';
import { ContextWrapper } from '../../context/ContextWrapper';

const PageHeadingTexts: React.FC = () => {
    const { isAdminFlow } = useContext(ContextWrapper);
    return (
        <div className="page-heading-texts" data-testid="page-heading-texts">
            {isAdminFlow ? (
                <>
                    <p data-testid="adminFlowWelcomeText1">{message('adminFlowWelcomeText1')}</p>
                    <p data-testid="adminFlowWelcomeText2">{message('adminFlowWelcomeText2')}</p>
                    <p data-testid="adminFlowWelcomeText3">{message('adminFlowWelcomeText3')}</p>
                    <p data-testid="adminFlowWelcomeText4">{message('adminFlowWelcomeText4')}</p>
                    <p data-testid="adminFlowWelcomeText5">{message('adminFlowWelcomeText5')}</p>
                </>
            ) : (
                <>
                    <p data-testid="welcomeText1">{message('welcomeText1')}</p>
                    <p data-testid="welcomeText2">{message('welcomeText2')}</p>
                    <p data-testid="welcomeText3">{message('welcomeText3')}</p>
                </>
            )}
            <p className="opux-spacing-bottom-margin-double" data-testid="timeout">
                {message('sessionTimeoutWarningText')}
            </p>
        </div>
    );
};

export default PageHeadingTexts;
